import React from "react";

export function About() {
  return <div>Jasserei.ch created by Puurle @ 2021</div>;
}
